import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
  currentTab: string = 'Overview';

  constructor(private router: Router) { }

  ngOnInit(): void {
  }

  // Navigate back to dashboard when My Account is clicked
  goToMyAccount(): void {
    this.router.navigate(['/dashboard/welcome']);
  }

  // Logout functionality
  logout(): void {
    // Clear all localStorage data
    localStorage.removeItem('token');
    localStorage.removeItem('Id');
    localStorage.removeItem('UserName');
    localStorage.removeItem('email');
    
    // Navigate to login page
    this.router.navigate(['/']);
  }
}
